import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { IMAGES, scrollToPrice, PURCHASE_LINK } from '../utils/constants';
import { motion } from 'framer-motion';
import { ClockIcon, CheckCircleIcon } from 'lucide-react';
export function HeroSection() {
  return <>
      {/* Thin urgency top bar with countdown */}
      <div className="bg-red-700 text-white py-1.5 px-4 sticky top-0 z-50" data-id="element-99">
        <div className="max-w-5xl mx-auto flex items-center justify-center gap-3 md:gap-5 flex-wrap" data-id="element-100">
          <span className="animate-pulse text-sm" data-id="element-101">🔥</span>
          <span className="font-bold text-xs md:text-sm uppercase tracking-wider text-white" data-id="element-102">
            Oferta por tiempo limitado
          </span>
          <div className="hidden md:block w-px h-4 bg-red-400" data-id="element-103"></div>
          <div className="flex items-center gap-1.5" data-id="element-104">
            <ClockIcon className="w-3.5 h-3.5 text-red-200" data-id="element-105" />
            <CountdownTimer compact data-id="element-106" />
          </div>
        </div>
      </div>

      <section className="relative bg-orange-50/70 pt-10 pb-4" data-id="element-107">
        {/* Background decorative elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-108">
          <div className="absolute -top-24 -right-24 w-96 h-96 bg-orange-100 rounded-full blur-3xl opacity-40" data-id="element-109"></div>
          <div className="absolute top-1/2 -left-24 w-72 h-72 bg-yellow-100 rounded-full blur-3xl opacity-40" data-id="element-110"></div>
        </div>

        <div className="max-w-5xl mx-auto px-4 relative z-10 flex flex-col items-center text-center" data-id="element-111">
          {/* Main Title */}
          <motion.h1 initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          delay: 0.1
        }} className="text-5xl md:text-8xl font-black tracking-tight mb-0 uppercase leading-none" data-id="element-112">
            <span className="text-gray-900" data-id="element-113">MEGA PACK</span>{' '}
            <span className="text-orange-500" data-id="element-114">INGLÉS</span>
          </motion.h1>

          {/* Product Image - Clickable to scroll to price */}
          <motion.div initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: 0.2
        }} className="w-full max-w-2xl mx-auto my-3 cursor-pointer relative group" onClick={scrollToPrice} data-id="element-115">
            <div className="absolute inset-0 bg-orange-500/10 rounded-3xl blur-xl group-hover:bg-orange-500/20 transition-all duration-300" data-id="element-116"></div>
            <img src={IMAGES.main} alt="Mega Pack Inglés - Kit Completo" className="relative z-10 w-full h-auto drop-shadow-2xl group-hover:scale-105 transition-transform duration-500" data-id="element-117" />
          </motion.div>

          {/* Subtitle & Value Line */}
          <motion.div initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: 0.3
        }} data-id="element-118">
            <h2 className="text-xl md:text-2xl font-black text-gray-700 mb-4 uppercase leading-snug" data-id="element-119">
              No más estrés. No más horas planificando.
              <br data-id="element-120" />
              <span className="text-orange-500" data-id="element-121">
                Recursos listos para usar.
              </span>
            </h2>
            <div className="flex flex-col sm:flex-row items-stretch justify-center gap-3 mb-5 w-full max-w-2xl" data-id="element-122">
              <div className="flex-1 bg-white border-2 border-orange-200 rounded-xl px-5 py-3 flex items-center gap-3 shadow-sm" data-id="element-123">
                <CheckCircleIcon className="w-7 h-7 text-green-500 flex-shrink-0" data-id="element-124" />
                <span className="font-black text-gray-800 text-sm md:text-base leading-tight" data-id="element-125">
                  +200 actividades listas para usar
                </span>
              </div>
              <div className="flex-1 bg-white border-2 border-orange-200 rounded-xl px-5 py-3 flex items-center gap-3 shadow-sm" data-id="element-126">
                <CheckCircleIcon className="w-7 h-7 text-green-500 flex-shrink-0" data-id="element-127" />
                <span className="font-black text-gray-800 text-sm md:text-base leading-tight" data-id="element-128">
                  6 Tomos + 3 Bonos exclusivos
                </span>
              </div>
              <div className="flex-1 bg-white border-2 border-orange-200 rounded-xl px-5 py-3 flex items-center gap-3 shadow-sm" data-id="element-129">
                <CheckCircleIcon className="w-7 h-7 text-green-500 flex-shrink-0" data-id="element-130" />
                <span className="font-black text-gray-800 text-sm md:text-base leading-tight" data-id="element-131">
                  Material listo para imprimir en PDF
                </span>
              </div>
            </div>
          </motion.div>

          {/* Description */}
          <motion.p initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: 0.4
        }} className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto mb-6 leading-relaxed font-medium" data-id="element-132">
            Herramientas listas para usar en secundaria: teoría express,
            worksheets imprimibles, speaking, evaluaciones y clave de
            respuestas. Multinivel A1–B2. PDF + editable.
          </motion.p>

          {/* CTAs */}
          <motion.div initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: 0.5
        }} className="w-full max-w-lg flex flex-col gap-3.5" data-id="element-133">
            <a href={PURCHASE_LINK} target="_blank" rel="noopener noreferrer" className="relative w-full bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white font-black text-2xl md:text-3xl py-6 px-8 rounded-2xl text-center shadow-[0_8px_0_#c2410c] hover:shadow-[0_4px_0_#c2410c] hover:translate-y-[4px] transition-all uppercase tracking-wide animate-pulse" data-id="element-134">
              <span className="relative z-10" data-id="element-135">🛒 ADQUIRIR AHORA</span>
            </a>

            <button onClick={scrollToPrice} className="w-full bg-white hover:bg-orange-50 text-orange-600 border-2 border-orange-300 font-bold text-lg py-4 px-8 rounded-xl text-center transition-all" data-id="element-136">
              MÁS INFO
            </button>

            <div className="mt-1 inline-flex items-center justify-center gap-2 bg-orange-100 border border-orange-300 rounded-full px-5 py-1.5 mx-auto" data-id="element-137">
              <span className="text-orange-600 font-black text-base md:text-lg tracking-tight" data-id="element-138">
                🔥 +2000 profes ya lo usan en sus clases
              </span>
            </div>
          </motion.div>
        </div>
      </section>
    </>;
}